import { GetterTree } from "vuex";
import { IState } from "../../IState";
import { IUser } from "./IUser";
import { WireEntities } from "@timesheets/common";

export const getters: GetterTree<IUser, IState> = {
  disabledRoles(state: IUser): WireEntities.Roles.IRecruitmentAgencyRole[] {
    const disabledRoles = state.roles.filter(role => role.isEnabled);

    return disabledRoles;
  },
  enabledRoles(state: IUser): WireEntities.Roles.IRecruitmentAgencyRole[] {
    const enabledRoles = state.roles.filter(role => role.isEnabled);

    return enabledRoles;
  },
};
